// Этот файл генерируется автоматически, его не следует редактировать вручную
import form from '@/widgets/form.js';
import formsConditional from '@/widgets/formsConditional.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import mobileHeader from '@/widgets/mobileHeader.js';
import popup from '@/widgets/popup.js';
import requestPopup from '@/widgets/requestPopup.js';
import scrollTop from '@/widgets/scrollTop.js';
import scrollerHorizontal from '@/widgets/scrollerHorizontal.js';
import selectNotEmpty from '@/widgets/selectNotEmpty.js';
import showPopupMenu from '@/widgets/showPopupMenu.js';
import telField from '@/widgets/telField.js';
import toggleClass from '@/widgets/toggleClass.js';
import upload from '@/widgets/upload.js';

export default {
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'folder': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/folder.js'),
  'form': async () => { return { default: form }; },
  'formsConditional': async () => { return { default: formsConditional }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'mobileHeader': async () => { return { default: mobileHeader }; },
  'popup': async () => { return { default: popup }; },
  'requestPopup': async () => { return { default: requestPopup }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'scrollerHorizontal': async () => { return { default: scrollerHorizontal }; },
  'selectNotEmpty': async () => { return { default: selectNotEmpty }; },
  'showPopupMenu': async () => { return { default: showPopupMenu }; },
  'telField': async () => { return { default: telField }; },
  'toggleClass': async () => { return { default: toggleClass }; },
  'upload': async () => { return { default: upload }; }
};
